"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyId: zod_1.z.number(),
});
exports.path = '/irrigation-scheduler-publish';
//# sourceMappingURL=index.js.map